import { createStore, applyMiddleware } from "redux";
import { createEpicMiddleware } from "redux-observable";
import { rootEpic, rootReducer, hideActionsFromDevTools } from "@dux";
import epicDependencies from "@services/epicDependencies";
import createHubMiddleware from "@/middlewares/hubMiddleware";

const epicMiddleware = createEpicMiddleware({
  dependencies: epicDependencies,
});

let enhancer = applyMiddleware(epicMiddleware, createHubMiddleware());
if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  enhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    actionsDenylist: hideActionsFromDevTools,
  })(enhancer);
}

const store = createStore(rootReducer, enhancer);

epicMiddleware.run(rootEpic);

// TODO: implement hmr with vite plugin
// if (module.hot) {
//   module.hot.accept(() => {
//     const nextRootReducer = await import("@dux").rootReducer;
//     store.replaceReducer(nextRootReducer);
//   });
// }

export default store;
